import {
  FluentProvider,
  ProgressBar,
  tokens,
} from '@fluentui/react-components';
import { useActiveTheme } from '../theme/ThemeContext';

interface InlineProgressProps {
  label?: string;
}

const InlineProgress = ({ label = 'Loading...' }: InlineProgressProps) => {
  const theme = useActiveTheme();
  return (
    <FluentProvider theme={theme}>
      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          gap: 12,
          padding: '40px 0',
        }}
      >
        <ProgressBar style={{ width: 200 }} />
        <span style={{ color: tokens.colorNeutralForeground3, fontSize: 13 }}>
          {label}
        </span>
      </div>
    </FluentProvider>
  );
};

export default InlineProgress;
